import * as React from "react";
import { useIconState } from "./useIconState";
const wrapIcon = (icon, displayName) => {
  const Component = props => {
    const state = useIconState(props);
    return React.cloneElement(icon, state);
  };
  Component.displayName = displayName;
  return Component;
};
export default wrapIcon;